/* Per-grind brew guide.
   Reads a variantId -> brew-text map rendered by the product section and swaps
   the accordion content whenever the buy box resolves a new variant
   (the <subscription-builder> dispatches `sb:variantchange`). Hides the whole
   accordion when the selected variant has no guide. */
(function () {
  if (customElements.get('brew-guide')) return;

  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  class BrewGuide extends HTMLElement {
    connectedCallback() {
      var dataEl = this.querySelector('[data-brew-map]');
      try {
        this.map = JSON.parse(dataEl.textContent);
      } catch (e) {
        this.map = {};
      }
      this.details = this.querySelector('[data-brew-details]');
      this.content = this.querySelector('[data-brew-content]');

      this._onVariant = this.onVariant.bind(this);
      document.addEventListener('sb:variantchange', this._onVariant);

      // Sync to whatever the buy box has already selected on load.
      var input = document.querySelector('.sb__variant-id');
      if (input && input.value) this.update(input.value);
    }

    disconnectedCallback() {
      document.removeEventListener('sb:variantchange', this._onVariant);
    }

    onVariant(e) {
      if (e.detail && e.detail.variantId != null) this.update(e.detail.variantId);
    }

    update(variantId) {
      if (!this.details || !this.content) return;
      var raw = this.map[String(variantId)];
      if (raw && raw.trim()) {
        this.content.innerHTML = escapeHtml(raw).replace(/\n/g, '<br>');
        this.details.hidden = false;
      } else {
        this.details.hidden = true;
        this.details.removeAttribute('open');
      }
    }
  }

  customElements.define('brew-guide', BrewGuide);
})();
